import { render, staticRenderFns } from "./VendorPhoneEmail.vue?vue&type=template&id=26bd11cc"
import script from "./VendorPhoneEmail.vue?vue&type=script&lang=js"
export * from "./VendorPhoneEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports